var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sky-input",style:(_vm.$attrs.style),domProps:{"innerHTML":_vm._s(_vm.selfData)}})
}
var staticRenderFns = []

export { render, staticRenderFns }